import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{
      borderTop: "1px solid var(--border)",
      padding: "28px 32px",
      marginTop: 40,
    }}>
      <div style={{
        maxWidth: 960,
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 16,
      }}>
        {/* Brand */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 18 }}>🗳️</span>
          <div>
            <div style={{
              fontFamily: "var(--font-display)",
              fontWeight: 700,
              fontSize: 13,
              color: "var(--text-secondary)",
            }}>
              BALLOT D.A.
            </div>
            <div style={{
              fontFamily: "var(--font-mono)",
              fontSize: 9,
              color: "var(--text-muted)",
              letterSpacing: "0.1em",
            }}>
              ELECTION READINESS SCORER™
            </div>
          </div>
        </div>

        {/* Links */}
        <div style={{
          display: "flex",
          gap: 20,
          fontSize: 12,
          color: "var(--text-muted)",
        }}>
          {["Privacy Policy", "Terms of Service", "Contact Sales", "Documentation"].map((l) => (
            <span
              key={l}
              style={{ cursor: "pointer", transition: "color 0.2s" }}
              onMouseEnter={(e) => (e.target.style.color = "var(--text-secondary)")}
              onMouseLeave={(e) => (e.target.style.color = "var(--text-muted)")}
            >
              {l}
            </span>
          ))}
        </div>

        {/* Copyright */}
        <div style={{
          fontFamily: "var(--font-mono)",
          fontSize: 11,
          color: "var(--text-muted)",
        }}>
          © {year} Ballot D.A. · Confidential
        </div>
      </div>
    </footer>
  );
}
